// extracted by mini-css-extract-plugin
export default {"title":"Menu_title__-g1VZ","quiz":"Menu_quiz__oJQ86"};